import React from 'react';
import { ArrowDown, Loader2 } from 'lucide-react';
import { CONTENT_TOP } from './chromeMetrics';
import { PULL_THRESHOLD } from './usePullToRefresh';

/**
 * The pull-to-refresh disc. It slides down from behind the fixed header as the
 * feed is pulled; the arrow turns to point up once letting go would refresh,
 * then becomes a spinner while the feed reloads. Reduced motion: no slide or
 * spin, the disc just appears.
 */
export function PullIndicator({ pull, refreshing, reduceMotion }: { pull: number; refreshing: boolean; reduceMotion: boolean }) {
  if (pull <= 0 && !refreshing) return null;
  const progress = Math.min(1, pull / PULL_THRESHOLD);
  const ready = progress >= 1;
  const offset = reduceMotion ? 12 : pull - 28;
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={refreshing ? 'Refreshing' : ready ? 'Release to refresh' : 'Pull to refresh'}
      className="pointer-events-none fixed left-1/2 z-10 flex h-9 w-9 items-center justify-center rounded-full border border-line bg-paper-raised text-ink-2 shadow-sm"
      style={{
        top: CONTENT_TOP,
        transform: `translate(-50%, ${offset}px)`,
        opacity: reduceMotion ? 1 : Math.max(0.25, progress),
        transition: pull === PULL_THRESHOLD || pull === 0 ? 'transform 200ms ease-out' : undefined,
      }}
    >
      {refreshing ? (
        <Loader2 className="h-4 w-4 animate-spin motion-reduce:animate-none" strokeWidth={2} aria-hidden />
      ) : (
        <ArrowDown
          className="h-4 w-4 transition-transform duration-150 ease-out motion-reduce:transition-none"
          style={{ transform: ready ? 'rotate(180deg)' : undefined }}
          strokeWidth={2}
          aria-hidden
        />
      )}
    </div>
  );
}
